import { customAlphabet } from 'nanoid';

// Only use lowercase alphanumeric characters for IDs
const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
const ID_LENGTH = 4;

// Create a nanoid generator with our custom alphabet
export const generateId = customAlphabet(ALPHABET, ID_LENGTH); 